import { render, staticRenderFns } from "./YouTubeRegularDialog.vue?vue&type=template&id=5223200e&scoped=true"
import script from "./YouTubeRegularDialog.vue?vue&type=script&lang=js"
export * from "./YouTubeRegularDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5223200e",
  null
  
)

export default component.exports